module.exports = __webpack_public_path__ + "img/home-2.e9158f88.webp";